import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const useHashScroll = () => {
  const location = useLocation();

  // Function to scroll to hash element (memoized to prevent infinite re-renders)
  const scrollToHash = useCallback((hash) => {
    if (!hash) return;

    // Remove the # from hash
    const elementId = hash.replace('#', '');
    const element = document.getElementById(elementId);

    if (element) {
      // Calculate navbar height for offset
      const navbar = document.querySelector('.navbar');
      const navbarHeight = navbar ? navbar.offsetHeight : 80; // Default 80px if navbar not found
      
      // Additional offset for better visual spacing
      const additionalOffset = 20;
      const totalOffset = navbarHeight + additionalOffset;

      // Calculate scroll position
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - totalOffset;

      // Smooth scroll to position
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Add a small highlight effect to the target element
      element.style.transition = 'all 0.3s ease';
      element.style.transform = 'scale(1.02)';
      element.style.boxShadow = '0 4px 20px rgba(59, 130, 246, 0.2)';
      
      // Remove highlight after animation
      setTimeout(() => {
        element.style.transform = '';
        element.style.boxShadow = '';
      }, 1000);
    }
  }, []);

  useEffect(() => {
    // Handle hash on location change
    if (location.hash) {
      // Small delay to ensure the page has rendered
      const timer = setTimeout(() => {
        scrollToHash(location.hash);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [location, scrollToHash]);

  // Return function for manual scrolling (for same-page navigation)
  const scrollToElement = (elementId) => {
    const hash = elementId.startsWith('#') ? elementId : `#${elementId}`;
    scrollToHash(hash);
  };

  return { scrollToElement };
};

export default useHashScroll;
